import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from '@printdeal/ui-library';
import { useLocation } from '@gatsbyjs/reach-router';
import queryString from 'query-string';

const MandateCallbackAlerts = () => {
  const location = useLocation();

  const callbackAlert = () => {
    const { status } = queryString.parse(location.search);

    switch (status) {
      case 'success':
        return (
          <Alert variant="success">
            <FormattedMessage id="account.mandates.callback.success" defaultMessage="The mandate has been successfully created." />
          </Alert>
        );
      case 'cancelled':
        return (
          <Alert variant="warning">
            <FormattedMessage id="account.mandates.callback.cancelled" defaultMessage="The creation or deactivation of the mandate has been cancelled." />
          </Alert>
        );
      case 'refused':
        return (
          <Alert variant="warning">
            <FormattedMessage id="account.mandates.callback.refused" defaultMessage="The mandate has been refused." />
          </Alert>
        );
      case 'error':
        return (
          <Alert variant="error">
            <FormattedMessage id="account.mandates.callback.error" defaultMessage="An error occurred while processing the mandate." />
          </Alert>
        );
      case 'deleted':
        return (
          <Alert variant="success">
            <FormattedMessage id="account.mandates.callback.deleted" defaultMessage="The mandate has been successfully deleted." />
          </Alert>
        );
      default:
        return null;
    }
  };

  return callbackAlert();
};

export default MandateCallbackAlerts;
